import { FilterItem } from '../filters';
import { INVOICE_TYPE_CLIENT, INVOICE_TYPE_SUPPLIER, InvoiceType } from './invoice-types';

export enum WccStatus {
  DRAFT = 'draft',
  READY = 'ready',
  SENT = 'sent',
  UPLOADED = 'uploaded',
  CONFIRMED = 'confirmed',
  ORIGINAL = 'original',
}

export const WCC_STATUSES_MAP = {
  [WccStatus.DRAFT]: 'Черновик',
  [WccStatus.READY]: 'Готов',
  [WccStatus.SENT]: 'Отправлен',
  [WccStatus.UPLOADED]: 'Загружен скан',
  [WccStatus.CONFIRMED]: 'Подтвержден',
  [WccStatus.ORIGINAL]: 'Оригинал',
};

export const WCC_STATUSES_ARRAY: FilterItem<WccStatus>[] = Object.values(WccStatus).map((status) => ({ id: status, label: WCC_STATUSES_MAP[status] }));

export const OUTCOMING_WCC_STATUSES_ARRAY: FilterItem<string>[] = Object.values(WccStatus)
  .filter((s) => s !== WccStatus.DRAFT)
  .map((status) => ({ id: status, label: WCC_STATUSES_MAP[status] }));

export const INCOMING_WCC_STATUSES_ARRAY: FilterItem<string>[] = Object.values(WccStatus)
  .filter((s) => ![WccStatus.READY, WccStatus.SENT].includes(s))
  .map((status) => ({ id: status, label: WCC_STATUSES_MAP[status] }));

export const getWccStatusesArrayByInvoiceType = (type: InvoiceType) => {
  if (type === INVOICE_TYPE_CLIENT) return OUTCOMING_WCC_STATUSES_ARRAY;
  if (type === INVOICE_TYPE_SUPPLIER) return INCOMING_WCC_STATUSES_ARRAY;
  throw new Error('Argument "type" is not an InvoiceType');
};
